import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";
import NewsBanner from "../ones/NewsBanner";

export default function View() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await appContext.getAllNews();
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">{getInlineLoader()}</div>
    );
  }

  return (
    <>
      <section
        className="page-hero text-white"
        style={{
          backgroundImage:
            "linear-gradient(120deg, rgba(18,60,140,0.9), rgba(18,60,140,0.6))",
        }}
      >
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-7" data-aos="fade-up">
              <p className="about-tag bg-light text-dark d-inline-flex align-items-center mb-3">
                TEF Updates
              </p>
              <h1 className="font-bold display-5 mb-3">News & Updates</h1>
              <p className="lead mb-0">
                Stories, announcements, and media freedom updates from Tanzania
                Editors’ Forum.
              </p>
            </div>
            <div className="col-lg-5 text-lg-end mt-4 mt-lg-0" data-aos="fade-left">
              <button
                className="btn btn-light btn-rounded btn-padded shadow-sm me-2"
                onClick={() => appContext.navTo({ item: "contact_us" })}
              >
                Contact us
              </button>
              <button
                className="btn btn-secondary btn-rounded btn-padded shadow-sm"
                onClick={() => appContext.navTo({ item: "about_us" })}
              >
                About TEF
              </button>
            </div>
          </div>
        </div>
      </section>

      <NewsBanner showHeader={false} />
      <Footer />
    </>
  );
}
